import { render, staticRenderFns } from "./NonPublicEventTab.vue?vue&type=template&id=e89117dc&lang=pug"
import script from "./NonPublicEventTab.vue?vue&type=script&lang=ts"
export * from "./NonPublicEventTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports